import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import TextAnimation from "react-animate-text";
import banner from "./../../images/home1.gif";
import CV from "../../file/cv.pdf";
import TextTransition, { presets } from "react-text-transition";
import "./Banner.css";

const TEXTS = [
  "front-end developer",
  "React Developer",
  "MERN stack developer",
  "Web Developer",
];

const Banner = () => {
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    const intervalId = setInterval(
      () => setIndex((index) => index + 1),
      3000 // every 3 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);
  return (
    <div>
      <Container>
        <Row>
          <Col
            className="d-flex justify-content-center align-items-center gap"
            xs={12}
            md={6}
          >
            <div>
              <TextAnimation>
                <h4 className="gap">Welcome to My website</h4>
                <h3>I am a junior </h3>
                <h4 className="text-primary">
                  <TextTransition
                    text={TEXTS[index % TEXTS.length]}
                    springConfig={presets.wobbly}
                  />
                </h4>

                <h3> with some skills of backend.</h3>
              </TextAnimation>
              <div className="py-4">
                <a className="resume_button2" href={CV} download>
                  <i className="fas fa-cog fa-spin me-2"></i>Download CV
                </a>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6}>
            <img
              className="w-100"
              style={{ height: "600px" }}
              src={banner}
              alt=""
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Banner;
